<template>
  <div class="medium-table" v-if="settingsStore.getRatesLoaded">
    <RateTable :data="settingsStore.getRates" @edit="showEditRate" @delete="askDeleteRate"></RateTable>
    <div class="buttons">
      <button class="accent" @click="() => vfm.open(rateModalId)"><b>+</b> Add rate</button>
    </div>
  </div>
  <Loader v-else></Loader>
  <RateFormModal :value="state.value" :modal-id="rateModalId" @close="closeModal" @create="create" @edit="edit">
  </RateFormModal>
  <ConfirmModal
    :modal-id="confirmModalId"
    text="Do you realy want to delete selected ?"
    confirm-text="Delete"
    @confirm="confirmDelete"
    @close="vfm.close(confirmModalId)">
  </ConfirmModal>  
</template>

<script setup lang="ts">
import RateTable from '@/components/tables/RateTable.vue';
import { useSettingsStore } from '@/stores/setting';
import { onMounted, reactive } from 'vue';
import RateFormModal from '@/components/modals/RateFormModal.vue';
import { useVfm } from 'vue-final-modal';
import { RateItem } from '@/services/entities/RateItem';
import ConfirmModal from "@/components/modals/ConfirmModal.vue";
import Loader from '@/components/util/Loader.vue';

const settingsStore = useSettingsStore();
const rateModalId = Symbol("rateModal");
const confirmModalId = Symbol("confirmModal");
const vfm = useVfm();

onMounted(async () => {
  await settingsStore.loadRates();
});

const state = reactive({
  value: {} as RateItem,
  reteIdForDeletion: {} as string,
});

async function create() {
  await settingsStore.createRate(state.value);
  vfm.close(rateModalId)
  state.value = {} as RateItem;
}

async function edit() {
  await settingsStore.updateRate(state.value);
  vfm.close(rateModalId)
  state.value = {} as RateItem;
}

function showEditRate(rateId: string) {
  state.value = settingsStore.getRates.find(a => a.id == rateId) as RateItem;
  vfm.open(rateModalId);
}

async function closeModal() {
  vfm.close(rateModalId);
  state.value = {} as RateItem;
  settingsStore.loadRates();
}

function askDeleteRate(rateId: string) {
  state.reteIdForDeletion = rateId;
  vfm.open(confirmModalId);
}

async function confirmDelete(){
  vfm.close(confirmModalId);
  await deleteRate();
}

async function deleteRate() {
  await settingsStore.deleteRate(state.reteIdForDeletion);
  state.value = {} as RateItem;
  state.reteIdForDeletion = {} as string;
}



</script>

<style scoped lang="scss"></style>
